import React from 'react';
import {AuthPage} from '../../components/AuthPage';
import {useAuth} from '../../hooks/auth';

export const AuthPageContainer: React.FC = () => {
  const {signInWithMetaMask} = useAuth();
  return <AuthPage signIn={signInWithMetaMask} />;
};
